export const modalToSearchThemeByCompany = {
    title: '企業検索',
    company: '企業名',
    placeholder: '英語で入力してください',
    listTitle: '企業一覧',
    countText: '該当：',
    countNumber: '件',
    noDataText: '※企業名を検索すると、検索結果が表示されます。'
}
